<template>
    <main id="container-wrap">

        <!-- Header -->
        <section id="content">

        <!-- Main Banner -->
            
            <div id="article">
                <div class="container">
                    <div class="text-box">
                        <p class="title">
                            美国教研团队，专门为母语非英语的孩子研发；
                        </p>
                        <p class="title">
                            包含听、说、读、写的全方位能力提升；
                        </p>
                        <p class="title">
                            原版启蒙学习规划，全面且高效的学习方式；
                        </p>
                        <p class="title">
                            一个会员即可享受自然拼读、分级阅读、场景视频、语法
                        </p>
                    </div>
                </div>
            </div>
            <div id="promo4">
                <template v-if="checkPromotion !== 'membership'">
                    <div class="top">
                        <img v-if="checkPromotion === '251220'"
                            class="gift" src="@/assets/membership/img/img-gift2.png" alt="gift" />
                        <div>
                            <p class="title">
                                {{
                                    checkPromotion === '251121' ? '双12年终优惠活动' : 
                                    checkPromotion === '251220' ? '寒假特别赠送' : 
                                    checkPromotion === '260126' ? '轻松快乐寒假' :
                                    ''
                                }}
                            </p>
                            <p class="desc">
                                <span>
                                    {{
                                        checkPromotion === '251121' ? '（仅限11月21日-12月16日）' : 
                                        checkPromotion === '251220' ? '（12月20日-1月25日）' : 
                                        checkPromotion === '260126' ? '（仅限1月26日-2月26日）' :
                                        ''
                                    }}
                                </span>
                            </p>
                        </div>
                        <!-- <img class="gift" src="@/assets/membership/img/img-gift2.png" alt="gift" /> -->
                        <!-- 
                        <div v-if="checkPromotion === '250910'">
                            <lottie-vue-player 
                                :src="JSON.stringify(require('@/assets/membership/img/double.json'))"
                                :autoplay="true"
                                :loop="true"
                                :playerControls="false"
                                class="lottie"
                            >
                            </lottie-vue-player>
                        </div> 
                        -->
                    </div>
                    <img v-if="checkPromotion === '251220'"
                        class="gift" src="@/assets/membership/img/img-gift2.png" alt="gift" />
                    <div class="products">
                        <div class="product no-padding">
                            <div class="add-badge badge-200" v-if="showBadge">
                            </div>
                            <div class="product-header" :class="{'left-align': showBadge}">
                                <p>2年卡</p>
                                <p>(2个孩子使用)</p>
                            </div>
                            <div class="product-body">
                                <template v-if="showOriginalPrice">
                                    <div class="break-line"></div>
                                    <p class="price original">1188</p>
                                </template>
                                <p class="price discount">
                                    <!-- <span class="min" v-if="checkPromotion === '0607'">最低</span> -->
                                    <span class="value">
                                        {{ '988' }}
                                    </span>
                                </p>
                                <p class="price-desc new">
                                    {{
                                        '加贈12个月'
                                    }}
                                </p>
                                <p class="price-desc sub" :class="{'color': checkPromotion === '251220'}">
                                    {{
                                        checkPromotion === '251121' || checkPromotion === '260126' ? '(每个孩子 0.45/天)' :
                                        checkPromotion === '251220' ? '送Orchard Toys配对和拼写1盒' : ''
                                    }}
                                </p>
                                <button @click='handleLinkClick("promotion", 0)'>立即购买</button>
                            </div>
                        </div>
                        <div class="product">
                            <div class="add-badge badge-200" v-if="showBadge">
                            </div>
                            <div class="product-header" :class="{'left-align': showBadge}">
                                <p>1年卡</p>
                                <p>(2个孩子使用)</p>
                            </div>
                            <div class="product-body">
                                <template v-if="showOriginalPrice">
                                    <div class="break-line"></div>
                                    <p class="price original">899</p>
                                </template>
                                <p class="price discount">
                                    <!-- <span class="min" v-if="checkPromotion === '0607'">最低</span> -->
                                    <span class="value">
                                        {{ '699' }}
                                    </span>
                                </p>
                                <p class="price-desc new">
                                    {{
                                        checkPromotion === '260126' ? '加赠10个月' : '加贈9个月'
                                    }}
                                </p>
                                <p class="price-desc sub" :class="{'color': checkPromotion === '251220'}">
                                    {{
                                        checkPromotion === '251121' || checkPromotion === '260126'? '(每个孩子 0.55/天)' : 
                                        checkPromotion === '251220' ? '送Orchard Toys配对和拼写1盒' : ''
                                    }}
                                </p>
                                <button @click='handleLinkClick("promotion", 1)'>立即购买</button>
                            </div>
                        </div>
                    </div>
                    <div class="products">
                        <div class="product no-padding">
                            <div class="add-badge" v-if="showBadge">
                            </div>
                            <div class="product-header" :class="{'left-align': showBadge}">
                                <p>半年卡</p>
                                <p>(2个孩子使用)</p>
                            </div>
                            <div class="product-body">
                                <template v-if="showOriginalPrice">
                                    <div class="break-line"></div>
                                    <p class="price original">680</p>
                                </template>
                                <p class="price discount">{{ '580' }}</p>
                                <p class="price-desc new">
                                    {{ 
                                        checkPromotion === '251121' ? '加赠5个月' : 
                                        checkPromotion === '251220' || checkPromotion === '260126'? '加赠6个月' :
                                        '加赠1个月' 
                                    }}
                                </p>
                                <p class="price-desc sub">
                                    {{ 
                                        checkPromotion === '251121' ? '(每个孩子 0.87/天)' : 
                                        checkPromotion === '251220' ? '(每个孩子 1.14/天)' : 
                                        '(每个孩子 0.75/天)'
                                    }}
                                </p>
                                <button @click='handleLinkClick("promotion", 2)'>立即购买</button>
                            </div>
                        </div>
                        <div class="product">
                            <div class="add-badge blank">
                                <p>新用户<br>专享</p>
                            </div>
                            <div class="product-header left-align">
                                <p>7日卡</p>
                                <p>(2个孩子使用)</p>
                            </div>
                            <div class="product-body">
                                <div class="break-line"></div>
                                <p class="price original">32</p>
                                <p class="price discount">{{ '9.9' }}</p>
                                <p class="price-desc new hide"></p>
                                <p class="price-desc sub">仅限新用户购买</p>
                                <button @click='handleLinkClick("promotion", 3)'>立即购买</button>
                            </div>
                        </div>
                    </div> 
                </template>
                <template v-else-if="type === 'membership'">
                    <p class="title">续费专用</p>
                    <p class="desc">
                        <span>减轻压力 续航学习时间!</span>
                    </p>
                    <div class="products">
                        <div class="product">
                            <div class="product-header">
                                <p>2年卡</p>
                                <p>(2个孩子使用)</p>
                            </div>
                            <div class="product-body">
                                <div class="break-line"></div>
                                <p class="price original">1188</p>
                                <p class="price discount">708</p>
                                <p class="price-desc">(每个孩子 0.48/天)</p>
                                <button @click='handleLinkClick("membership", 0)'>立即购买</button>
                            </div>
                        </div>
                        <div class="product">
                            <div class="product-header">
                                <p>1年卡</p>
                                <p>(2个孩子使用)</p>
                            </div>
                            <div class="product-body">
                                <div class="break-line"></div>
                                <p class="price original">899</p>
                                <p class="price discount">499</p>
                                <p class="price-desc">(每个孩子 0.75/天)</p>
                                <button @click='handleLinkClick("membership", 1)'>立即购买</button>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else-if="type === 'new'">
                    <p class="title">新注册专项</p>
                    <p class="desc">
                        <span>注册7日内下单, </span>
                        <span>立减 ¥200!</span>
                    </p>
                    <div class="products">
                        <div class="product">
                            <div class="add-badge badge-200"></div>
                            <div class="product-header left-align">
                                <p>2年卡</p>
                                <p>(2个孩子使用)</p>
                            </div>
                            <div class="product-body">
                                <div class="break-line"></div>
                                <p class="price original">1188</p>
                                <p class="price discount">988</p>
                                <p class="price-desc new">+ 加赠 6个月</p>
                                <p class="price-desc sub">(每个孩子 0.5/天)</p>
                                <button @click='handleLinkClick("new", 0)'>立即购买</button>
                            </div>
                        </div>
                        <div class="product">
                            <div class="add-badge badge-200"></div>
                            <div class="product-header left-align">
                                <p>1年卡</p>
                                <p>(2个孩子使用)</p>
                            </div>
                            <div class="product-body">
                                <div class="break-line"></div>
                                <p class="price original">899</p>
                                <p class="price discount">699</p>
                                <p class="price-desc new">+ 加赠 3个月</p>
                                <p class="price-desc sub">(每个孩子 0.75/天)</p>
                                <button @click='handleLinkClick("new", 1)'>立即购买</button>
                            </div>
                        </div>
                    </div>
                    <div class="products">
                        <div class="product">
                            <div class="add-badge badge-200"></div>
                            <div class="product-header left-align">
                                <p>半年卡</p>
                                <p>(2个孩子使用)</p>
                            </div>
                            <div class="product-body">
                                <div class="break-line"></div>
                                <p class="price original">680</p>
                                <p class="price discount">480</p>
                                <p class="price-desc new">+ 加赠 1个月</p>
                                <p class="price-desc sub">(每个孩子 1.1/天)</p>
                                <button @click='handleLinkClick("new", 2)'>立即购买</button>
                            </div>
                        </div>
                    </div> 
                </template>
                <template v-else-if="type === 'all'">
                    
                    <div class="products no-title">
                        <div class="product">
                            <div class="add-badge"></div>
                            <div class="product-header left-align">
                                <p>2年卡</p>
                                <p>(2个孩子使用)</p>
                            </div>
                            <div class="product-body">
                                <div class="break-line"></div>
                                <p class="price original">1188</p>
                                <p class="price discount">1088</p>
                                <p class="price-desc new">+ 加赠 6个月</p>
                                <p class="price-desc sub">(每个孩子 0.6/天)</p>
                                <button @click='handleLinkClick("all", 0)'>立即购买</button>
                            </div>
                        </div>
                        <div class="product">
                            <div class="add-badge"></div>
                            <div class="product-header left-align">
                                <p>1年卡</p>
                                <p>(2个孩子使用)</p>
                            </div>
                            <div class="product-body">
                                <div class="break-line"></div>
                                <p class="price original">899</p>
                                <p class="price discount">799</p>
                                <p class="price-desc new">+ 加赠 3个月</p>
                                <p class="price-desc sub">(每个孩子 0.88/天)</p>
                                <button @click='handleLinkClick("all", 1)'>立即购买</button>
                            </div>
                        </div>
                    </div>
                    <div class="products">
                        <div class="product">
                            <div class="add-badge"></div>
                            <div class="product-header left-align">
                                <p>半年卡</p>
                                <p>(2个孩子使用)</p>
                            </div>
                            <div class="product-body">
                                <div class="break-line"></div>
                                <p class="price original">680</p>
                                <p class="price discount">580</p>
                                <p class="price-desc new">+ 加赠 1个月</p>
                                <p class="price-desc sub">(每个孩子 1.35/天)</p>
                                <button @click='handleLinkClick("all", 2)'>立即购买</button>
                            </div>
                        </div>
                    </div> 
                </template>
            </div>

            <!-- 
            <div id="promo1">
                <div class="container">
                    <div id="product">
                        <p class="product-title">六个月会员卡</p>
                        <div class="price">
                            <span class="percent">12%</span><span class="original-price">768 RMB</span>
                        </div>
                        <p class="discount-price">680<span class="unit-price"> 元</span></p>
                        <p class="m-price">（ <span style="font-weight: 500;">3.7</span> 元/天 ）</p>
                        <div id="btn">
                            <input class="red-btn" type="button" align="center" value="立即购买" v-on:click='handleLinkClick(0)'>
                        </div>
                    </div>

                    <div class="line mobile-show"></div>

                    <div id="product" class="badge1"> 
                        <p class="product-title">一年会员卡</p>
                        <div class="price">
                            <span class="percent">25%</span><span class="original-price">1188 RMB</span>
                        </div>
                        <p class="discount-price">899<span class="unit-price"> 元</span></p>
                        <p class="m-price">（ <span style="font-weight: 500;">2.5</span> 元/天 ）</p>
                        <div id="btn">
                            <input class="red-btn" type="button" align="center" value="立即购买" v-on:click='handleLinkClick(1)'>
                        </div>
                    </div>

                    <div class="line mobile-show"></div>

                    <div id="product" class="badge2">
                        <p class="product-title">两年会员卡</p>
                        <div class="price">
                            <span class="percent">45%</span><span class="original-price">2198 RMB</span>
                        </div>
                        <p class="discount-price">1188<span class="unit-price"> 元</span></p>
                        <p class="m-price">（ <span style="font-weight: 500;">1.6</span> 元/天 ）</p>
                        <div id="btn">
                            <input class="red-btn" type="button" align="center" value="立即购买" v-on:click='handleLinkClick(2)'>
                        </div>
                    </div>

                    <img class="worksheet" src="@/assets/membership/img/img-worksheet.png" alt="敬请期待">

                </div>
            </div>
            -->

            <div id="promo2">
                <div class="container">
                    <div class="qr-code">
                        <h2>关注官方公众号</h2>
                        <p>了解更多<span>优惠</span>活动</p>
                        <img src="@/assets/membership/img/img-qrcode.png" class="img-qrcode">
                    </div>

                    <div class="vertical-line"></div>

                    <div class="qr-code">
                        <h2>官方企微客服</h2>
                        <p>1v1人工客服</p>
                        <img src="@/assets/membership/img/img-qqcode2.png" class="img-qqcode">
                    </div>
                </div>
            </div>

            <div id="promo3">
                <div class="container">
                    <h2 class="title">用户购前须知</h2>
                    <p>支持本页所购商品，下单后7日内无理由退款。超出7日后，不支持退款申请。</p>
                    <p>购买年卡赠送的练习册及其他周边产品一经拆封，不支持退货退款。</p>
                    <p>希注册用户体验会员期间购买并激活年卡，您的使用时间将累计。</p>
                    <p>收到激活码后请在30天内完成激活兑换，如过期未激活者码将失效，请及时联系官方客服咨询解决方案。</p>
                    <p>会员一经激活则正式生效，请确认您激活时登陆使用的账号是否准确，且该账号为您个人使用。如使用非法账号或非个人账号造成的经济损失将由您自行承担。</p>
                    <p>都都GO（原都都英语）要求设备为支持 IOS 15及以上，Android 10及以上的手机或平板电脑、学习机，如使用期间有卡顿、启动闪退等问题，请及时升级您的设备系统。</p>
                    <p>都都会员支持多平台互通，即不论您是安卓设备还是苹果设备，均可登陆同一账号。</p>
                    <p>都都会员仅支持最多不超过5台设备上同时登录。多设备登录极易发生存档丢失、学习进度丢失及其它错误。建议您使用时只在一台设备上进行。</p>
                    <p>为了保证您的财产安全，请不要将您的账号分享给陌生人使用。</p>
                    <p>我们将严厉打击盗版、倒卖非法账号、倒卖激活码的不法行为，同时都都会员不允许一个账号分销给多个用户使用，一经发现将对非法账号和激活码进行封号处理。非正式途径购买账号或激活码造成的经济损失，将由您自行承担。</p>
                    <p>欢迎关注官方微信公众号：都都APP ，如有疑问可咨询官方人工客服（关注微信公众号-转人工客服即可），或官方举报投诉电话：（+86）18810316494.</p>
                </div>
            </div>

        </section>

        <footer>
            <div class="container">
                <p class="rights">ⓒ 2021 Enuma, Inc. All Rights Reserved.</p>
                <div>
                    <p>深圳埃努码信息技术有限公司</p>
                    <p class="v-line"></p>
                    <p style="cursor:pointer" @click="onClickFooterLink(0)">粤ICP备2022075939号</p>
                    <p class="v-line"></p>
                    <div class="ovcn" style="cursor:pointer" @click="onClickFooterLink(1)">
                        <img src="@/assets/common/icn_beiangovcn.png" alt="" />
                        <p>京公网安备 11010502050400号</p>
                    </div>
                </div>
                <p>深圳市南山区南头街道大汪山社区桃园东路1号 西海明珠花园F座2117-1</p>
            </div>
        </footer>

    </main>
</template>
<script>

export default {
    computed : {
        type() {
            if (this.$route.query.type === 'new' || this.$route.query.type === 'membership') {
                return this.$route.query.type
            }
            return 'all'
        },
        servertime() {
            return this.$store.state.servertime
        },
        checkPromotion() {
            if (!this.servertime) return 'membership'
            const promotions = [
                {
                    title: '251121',
                    start: '2025-11-21 01:00:00',
                    end: '2025-12-17 01:00:00'
                },
                {
                    title: '251220',
                    start: '2025-12-20 01:00:00',
                    end: '2026-01-26 01:00:00'
                },
                {
                    title: '260126',
                    start: '2026-01-26 01:00:00',
                    end: '2026-02-27 01:00:00'
                }
            ]
            const now = this.$moment(this.servertime)
            let promotion = 'membership'
            
            for (const p of promotions) {
                const checkStart = now.isAfter(this.$moment(p.start))
                const checkEnd = now.isBefore(this.$moment(p.end))
                
                if (
                    process.env.NODE_ENV === 'production' && 
                    checkStart && 
                    checkEnd
                    || process.env.NODE_ENV !== 'production' && 
                    checkEnd
                ) {
                    promotion = p.title
                    break
                }
            }
            if (process.env.NODE_ENV !== 'production' &&
                 this.$route.query.test &&
                 promotions.find((promotion) => {
                    return promotion.title === this.$route.query.test
                 })) {
                promotion = this.$route.query.test
            }

            return promotion
        },
        showBadge() {
            return this.checkPromotion !== '251220' && this.checkPromotion !== '260126'
        },
        showOriginalPrice() {
            return this.checkPromotion !== '251220' && this.checkPromotion !== '260126'
        }
    },
    mounted() {
        this.checkServerTime()
    },
    methods: {
        checkServerTime() {
            if (!this.servertime) {
                setTimeout(this.checkServerTime, 100)
                return
            }
        },
        handleLinkClick(type, index) {
            const links = {
                "new": [
                    "https://shop91489875.m.youzan.com/wscgoods/detail/35y9nwlad0dq38j?scan=1&activity=none&from=kdt&qr=directgoods_3801576448&shopAutoEnter=1",
                    "https://shop91489875.m.youzan.com/wscgoods/detail/3npjt5comlz2zh4?scan=1&activity=none&from=kdt&qr=directgoods_3801584756&shopAutoEnter=1",
                    "https://shop91489875.m.youzan.com/wscgoods/detail/27cx3zxwqjr5727?scan=1&activity=none&from=kdt&qr=directgoods_2878500615&shopAutoEnter=1"
                ],
                "membership": [
                    "https://shop91489875.m.youzan.com/wscgoods/detail/3f1xxe0cueajfjp?scan=1&activity=none&from=kdt&qr=directgoods_3801584580&shopAutoEnter=1",
                    "https://shop91489875.m.youzan.com/wscgoods/detail/2x5pjcgc3ahhnw2?scan=1&activity=none&from=kdt&qr=directgoods_2878500740&shopAutoEnter=1"
                ],
                "all": [
                    "https://shop91489875.m.youzan.com/wscgoods/detail/1yj55vk0h4pfv?scan=1&activity=none&from=kdt&qr=directgoods_875457606&shopAutoEnter=1",
                    "https://shop91489875.m.youzan.com/wscgoods/detail/1ye8ngkc8qm2j?scan=1&activity=none&from=kdt&qr=directgoods_888303865&shopAutoEnter=1",
                    "https://shop91489875.m.youzan.com/wscgoods/detail/3nfq9e1q7aoq3?scan=1&activity=none&from=kdt&qr=directgoods_888245981&shopAutoEnter=1"
                ],
                "promotion": [
                    "https://sourl.co/m4fpd9",
                    "https://sourl.co/LDXP6m",
                    "https://shop91489875.m.youzan.com/wscgoods/detail/3nfq9e1q7aoq3?scan=1&activity=none&from=kdt&qr=directgoods_888245981&shopAutoEnter=1",
                    "https://shop91489875.m.youzan.com/wscgoods/detail/2omys8klrnxyjui?scan=1&activity=none&from=kdt&qr=directgoods_4095495506&shopAutoEnter=1"
                ]
            }

            const url = links[type][index]
            if (url) {
                window.open(url, '_blank')
            }
        },
        onClickFooterLink(index) {
            if (index === 0) {
                window.open('https://beian.miit.gov.cn/#/Integrated/index', '_blank')
            } else if (index === 1) {
                window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502050400', '_blank')
            }
        }
    }
}
</script>
<style scoped src="@/assets/membership/style.css" />